// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"717":"04065bf1","862":"7c036e50"}[chunkId] + ".chunk.js";
};